<template>
  <div
    :class="['page-login', isModal ? 'page-login-modal' : 'page-login-full']"
    :style="isModal ? {} : fullStyle"
  >
    <div class="container">
      <div class="page-login-box" :style="screenWidth > 429 ? {} : { width: screenWidth + 'px' }">
        <div class="mod-account">
          <a-tabs @change="onAccountChange">
            <a-tab-pane key="account" :tab="accountTitle" forceRender>
              <a-form :form="accountForm" @submit="onAccountSubmit">
                <a-form-item>
                  <a-input
                    size="large"
                    :placeholder="accountPlaceholder"
                    v-decorator="[
                      'username',
                      {
                        rules: [
                          {
                            validator: handleAccountFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @change="onUserNameChange"
                  >
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input
                    size="large"
                    :placeholder="system === 'owner' ? '请输入金鹏卡密码' : '请输入密码'"
                    type="password"
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: handleAccountFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                    <a-icon slot="prefix" type="lock" />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <user-slider-captcha style="width: 350px;" ref="verify" size="large" @change="onCaptchVerify">
                  </user-slider-captcha>
                </a-form-item>
                <a-form-item v-if="rule === 'v2'">
                  <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="0" :areaCode="areaCode" :value="phoneForInput" :token="token" type="input" @change="onVerificationCodeChangeForInput">
                  </user-verification-code>
                </a-form-item>
                <a-form-item>
                  <a-button style="width: 100%;" size="large" type="primary" html-type="submit" :loading="loading">登录</a-button>
                </a-form-item>
              </a-form>
            </a-tab-pane>
            <a-tab-pane v-if="system === 'owner' && userType === 0" key="mobile" tab="手机登录" forceRender>
              <a-form :form="mobileForm" @submit="onMobileSubmit">
                <mobile-input
                  prefix="user"
                  :form="mobileForm"
                  :validateHandler="handleMobileFieldValidate"
                  @change="onPhoneChange"
                ></mobile-input>
                <a-form-item>
                  <user-slider-captcha style="width: 350px;" ref="mobileVerify" size="large" @change="onCaptchMobileVerify">
                  </user-slider-captcha>
                </a-form-item>
                <a-form-item>
                  <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :areaCode="areaCode" :smsType="0" :value="phone" :token="mobileToken" @change="onVerificationCodeChange">
                  </user-verification-code>
                </a-form-item>
                <a-form-item>
                  <a-button style="width: 100%;" size="large" type="primary" html-type="submit" :loading="loading">登录</a-button>
                </a-form-item>
              </a-form>
            </a-tab-pane>
          </a-tabs>
          <div class="links">
            <template v-if="registerUrl">
              <a @click="toRegister">{{ userType === 0 ? '注册' : '代理人注册'}}</a>
              <span>|</span>
            </template>
            <a v-if="userType !== 3" @click="toForgetPassword">忘记密码</a>
          </div>
        </div>
        <!-- 屏蔽其他登录方式 -->
        <!-- <div class="mod-types" v-if="userType === 0 && (ffpLoginEnable || thirdParty.length)">
          其他登录方式:
          <template v-if="ffpLoginEnable">
            <span v-if="system === 'owner'" @click="onChangeSystem('ffp')">
              <user-icon type="icon-hainanhangkong1"></user-icon>
              {{ app.loginFfpTitle || '金鹏账号' }}
            </span>
            <span v-else @click="onChangeSystem('owner')">
              <user-icon :type="app.logo"></user-icon>
              {{ app.loginOwnerTitle || app.sortName }}账号
            </span>
          </template>
          <span v-for="item in thirdParty" :key="item.key" @click="onThirdPartyLogin(item)">
            <user-icon :type="item.icon" />
            {{ item.label }}
          </span>
        </div> -->
      </div>
    </div>
    <a-modal
      v-model="visibleWeakPasswordPopup"
      wrapClassName="weak-password-modal"
      title="温馨提示"
      :closable="false"
      :maskClosable="false"
      @ok="onOk"
      @cancel="onCancel"
    >
      <template slot="footer">
        <a-button v-if="pwErrorCode === 'PW_E01'" @click="onCancel">我已知晓</a-button>
        <a-button type="primary" @click="onOk">去修改</a-button>
      </template>
      <p v-html="passwordResetTipsMap[pwErrorCode]"></p>
      <a-checkbox v-if="pwErrorCode === 'PW_E01'" :style="{'marginTop': '20px'}" v-model="checkboxValue">暂不提醒</a-checkbox>
    </a-modal>
  </div>
</template>

<script>
import queryString from 'query-string'
import { find, get } from 'lodash'
import { validate } from '@/utils/validate'
import { login, logout, thirdPartyOauth, thirdPartyLogin, getSysConfig, loginNoRemindSet } from '@/api/login'
import eventBus from '../../components/eventBus.js'
import fromApp from '@/utils/from'
import './index'

const microBaseUrl = '/micro/user'
const thirdPartyOauths = [
  {
    key: 'wechat',
    icon: 'icon-weixin',
    label: '微信'
  },
  {
    key: 'alipay',
    icon: 'icon-zhifubao',
    label: '支付宝'
  },
  {
    key: 'qq',
    icon: 'icon-qq',
    label: 'QQ'
  }
]

const typeMap = {
  0: '用户名密码登录',
  2: '常客用户名密码登录',
  3: '手机验证码登录'
}

export default {
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      system: 'owner',
      type: 'account',
      thirdParty: [],
      accountForm: this.$form.createForm(this, { name: 'account' }),
      mobileForm: this.$form.createForm(this, { name: 'mobile' }),
      accountPlaceholder: '金鹏卡号/手机号/邮箱/护照号',
      phone: '',
      registerUrl: '',
      loading: false,
      token: '',
      finalToken: '',
      mobileToken: '',
      code: '',
      ffpLoginEnable: false,
      userType: 0,
      areaCode: '86',
      errCode: '',
      app: {},
      fullStyle: {
        height: '670px'
      },
      airline: window.__MICRO_ROOT__?.airline,
      rule: 'v1',
      phoneForInput: '',
      codeForInput: '',
      visibleWeakPasswordPopup: false,
      loginValues: {},
      loginInfo: {},
      passwordResetTipsMap: {},
      pwErrorCode: '',
      checkboxValue: false
    }
  },
  computed: {
    accountTitle () {
      const { system, userType } = this

      if (system === 'ffp') {
        return '金鹏登录'
      }

      let title = ''
      switch (userType) {
        case 1:
          title = '代理人登录'
          break
        case 3:
          title = '管理员登录'
          break
        default:
          title = '会员登录'
      }

      return title
    },
    screenWidth () {
      return document.body.clientWidth
    }
  },
  async created () {
    this.getCmsData()
    const { isModal, airline } = this
    const params = queryString.parse(location.search)
    let userAppConfig = {}

    if (!isModal) {
      this.logout()
    }

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })

    this.app = fromApp()
    this.done = isModal ? location.href : (params.__done__ || '')

    if (window.__MICRO_ROOT__) {
      const root = window.__MICRO_ROOT__
      const data = await root.cms?.getPageData(isModal ? 'user:/login' : 'default')

      if (data) {
        userAppConfig = data.config
      }

      root.eventBus.emit('user.logout')
    }

    let userType = 0

    if (params.userType && !isNaN(params.userType)) {
      this.userType = userType = params.userType - 0
    }

    if (userType === 0) {
      this.registerUrl = '/register'
    } else if (userType === 1) {
      this.registerUrl = '/company-register'
    }

    this.ffpLoginEnable = userAppConfig.ffpLoginEnable

    if (userAppConfig.thirdpartyOauth && userAppConfig.thirdpartyOauth.length) {
      const thirdParty = []

      userAppConfig.thirdpartyOauth.forEach(item => {
        const oauth = find(thirdPartyOauths, { key: item.source.toLocaleLowerCase() })

        if (oauth) {
          thirdParty.push({
            ...oauth,
            ...item
          })
        }
      })

      this.thirdParty = thirdParty
    }

    if (userAppConfig.fullStyle) {
      this.fullStyle = userAppConfig.fullStyle
    }

    if (airline === 'JD') {
      this.handleSysConfig()
    }
  },
  mounted () {
    const params = queryString.parse(location.search)

    if (params.state && params.timestamp && params.client_name) {
      this.thirdPartyLogin({
        state: params.state,
        timestamp: params.timestamp,
        client_name: params.client_name
      })
    }
  },
  methods: {
    async getCmsData () {
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData(this.isModal ? 'user:/login' : 'default')) ?? {}
      const jsonStrData = get(pageCmsData, 'passwordResetTips.data') ?? '{}'
      this.passwordResetTipsMap = JSON.parse(jsonStrData)
    },
    onOk () {
      // 修改密码
      this.visibleWeakPasswordPopup = false
      this.handleLogin(true, this.pwErrorCode === 'PW_E02')
    },
    async onCancel () {
      // 知晓弱密码
      this.visibleWeakPasswordPopup = false
      if (this.checkboxValue) {
        // 调用接口
        try {
          await loginNoRemindSet({ cid: this.loginInfo?.cid || '' })
        } catch (err) {
          this.$message.error(err.message)
        }
      }
      this.handleLogin(false, false)
    },
    async logout () {
      try {
        this.$ls.remove('USER_CENTER_INFO')
        await logout()
      } catch (err) {
        console.error(err)
      }
    },
    // 登录方式切换
    onAccountChange (type) {
      this.type = type
      this.$refs.verify.refresh()
      this.$refs.mobileVerify && this.$refs.mobileVerify.refresh()
      this.code = ''
    },
    // 官网、金鹏登录切换
    onChangeSystem (type) {
      this.system = type
      this.accountPlaceholder = type === 'owner' ? '金鹏卡号/手机号/邮箱/护照号' : '请输入金鹏卡号/身份证号'
      this.$refs.verify.refresh()
      this.$refs.mobileVerify && this.$refs.mobileVerify.refresh()
    },
    // 第三方登录
    async onThirdPartyLogin (item) {
      this.loading = true

      try {
        const data = await thirdPartyOauth({
          redirectUri: item.redirectUrl,
          source: item.source,
          outAppId: item.appId
        })

        location.replace(data.url)
      } catch (err) {
        this.$message.error(err.message)
        this.loading = false
      }
    },
    async thirdPartyLogin (params) {
      const { isModal } = this
      this.loading = true

      try {
        const { user: data } = await thirdPartyLogin(params)

        if (!data) {
          this.$message.error('网络异常，请稍候再试！')
          this.loading = false
          return
        }

        this.$message.success('登录成功')
        this.$ls.set('USER_CENTER_INFO', data)

        const userInfo = {
          ...data,
          token: this.$ls.get('USER_CENTER_TOKEN')
        }
        window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, userInfo)
      } catch (err) {
        if (err.code === 20002) {
          this.$message.success('登录成功')

          if (isModal) {
            window.__MICRO_ROOT__?.router?.replace({
              pathname: microBaseUrl + '/login-binding',
              query: {
                loginType: 'thirdParty',
                __done__: this.done
              }
            })
          } else {
            this.$router.replace({
              path: '/login-binding',
              query: {
                loginType: 'thirdParty',
                __done__: this.done
              }
            })
          }
        } else if (err.code === 20021) {
          const { user: data } = err.data

          this.$message.success('登录成功')

          this.$ls.set('USER_CENTER_INFO', data)

          const userInfo = {
            ...data,
            code: err.code,
            token: this.$ls.get('USER_CENTER_TOKEN')
          }
          window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, userInfo)
        } else {
          this.$message.error(err.message)
          this.loading = false
        }
      }
    },
    handleLogin (isToChangePassword, loginFail) {
      this.loading = false
      const { type, isModal, loginInfo, loginValues } = this
      if (!loginFail) {
        this.$message.success('登录成功')

        if (type === 'mobile' && !loginInfo.fullName) {
          this.loginInfo.fullName = '手机用户'
        }
        this.$ls.set('USER_CENTER_INFO', loginInfo)
        this.handleUniTrack(loginValues)

        const userInfo = {
          ...this.loginInfo,
          token: this.$ls.get('USER_CENTER_TOKEN'),
          __next__: isToChangePassword
        }
        window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, userInfo)
      }

      if (isToChangePassword) {
        const path = loginFail ? '/not-login-password' : 'password'
        const loginName = loginFail ? encodeURIComponent(loginValues.loginName) : undefined
        if (isModal) {
          window.__MICRO_ROOT__?.router?.replace({
            pathname: microBaseUrl + path,
            query: {
              type: 'newChange',
              loginName
            }
          })
        } else {
          this.$router.replace({
            path,
            query: {
              type: 'newChange',
              loginName
            }
          })
        }
      }
    },
    // 账号登录表单校验
    handleAccountFieldValidate (rule, value, callback) {
      validate('login-owner-account', this.accountForm.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    // 快捷登录表单校验
    handleMobileFieldValidate (rule, value, callback) {
      validate('login-owner-mobile', this.mobileForm.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    // 账号登录
    onAccountSubmit (e) {
      e.preventDefault()

      this.accountForm.validateFields((errors, values) => {
        if (!errors) {
          const { token, system, userType, rule, codeForInput, finalToken } = this

          if (!token) {
            this.$message.error('请拖动滑块完成验证！')
            return
          }

          const params = {
            userType,
            type: system === 'owner' ? 52 : 2,
            loginName: values.username,
            password: values.password,
            token: token,
            rule
          }
          if (rule === 'v2') {
            if (!codeForInput) {
              this.$message.error('请输入手机动态码！')
              return
            }

            if (!finalToken) {
              this.$message.error('请点击获取动态码！')
              return
            }

            params.smsCode = codeForInput
          }
          this.login(params)
        }
      })
    },
    // 快捷登录
    onMobileSubmit (e) {
      e.preventDefault()

      this.mobileForm.validateFields((errors, values) => {
        if (!errors) {
          const { mobileToken, finalToken, code, userType } = this

          if (!code) {
            this.$message.error('请输入手机动态码！')
            return
          }
          if (!mobileToken) {
            this.$message.error('请拖动滑块完成验证！')
            return
          }
          if (!finalToken) {
            this.$message.error('请点击获取动态码！')
            return
          }

          this.login({
            userType,
            type: 3,
            loginName: values.phone,
            password: code,
            areaCode: values.areaCode,
            token: finalToken
          })
        }
      })
    },
    // 登录接口
    async login (values) {
      const { isModal } = this

      this.loading = true
      this.loginValues = values
      try {
        const data = await login(values)

        this.loginInfo = data
        this.pwErrorCode = data.pwErrorCode || ''
        if (this.pwErrorCode === 'PW_E01') {
          this.visibleWeakPasswordPopup = true
          return
        }

        this.handleLogin(false, false)
      } catch (err) {
        if (err.code === 20004) {
          if (isModal) {
            window.__MICRO_ROOT__?.router?.replace({
              pathname: microBaseUrl + '/security',
              query: {
                hasAuth: 0,
                info: err.data.info
              }
            })
          } else {
            this.$router.replace({
              path: '/security',
              query: {
                hasAuth: 0,
                info: err.data.info
              }
            })
          }
        } else if (err.code === 20014) {
          if (isModal) {
            window.__MICRO_ROOT__?.router?.replace({
              pathname: microBaseUrl + '/security',
              query: {
                hasAuth: 1,
                info: err.data.info
              }
            })
          } else {
            this.$router.replace({
              path: '/security',
              query: {
                hasAuth: 1,
                info: err.data.info
              }
            })
          }
        } else if (err.code === 30021) {
          this.$message.success('登录成功')
          if (isModal) {
            window.__MICRO_ROOT__?.router?.replace({
              pathname: microBaseUrl + '/login-binding',
              query: {
                loginType: 'ffp',
                __done__: this.done
              }
            })
          } else {
            this.$router.replace({
              path: '/login-binding',
              query: {
                loginType: 'ffp',
                __done__: this.done
              }
            })
          }
        } else if (err.code === 20062) {
          this.pwErrorCode = 'PW_E02'
          this.visibleWeakPasswordPopup = true
        } else {
          this.$message.error(err.message)
          this.loading = false
          this.$refs.verify.refresh()
          this.$refs.mobileVerify && this.$refs.mobileVerify.refresh()
          if (err.code.toString().includes(1000)) {
            this.errCode = err.code
          }
        }
        this.handleUniTrack(values, err)
      }
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    },
    onPhoneChange ({ areaCode, phone }) {
      this.areaCode = areaCode
      this.phone = phone
    },
    onUserNameChange (e) {
      this.phoneForInput = e.target.value
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000) && this.rule === 'v2') {
        this.finalToken = value
      }
    },
    onCaptchMobileVerify (value) {
      this.mobileToken = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onVerificationCodeChangeForInput (value) {
      this.codeForInput = value
    },
    toRegister (e) {
      e.preventDefault()
      const { registerUrl, isModal } = this

      if (isModal) {
        window.__MICRO_ROOT__?.router?.push(microBaseUrl + registerUrl)
      } else {
        this.$router.push(registerUrl)
      }
    },
    toForgetPassword (e) {
      e.preventDefault()
      window.location.href = 'https://ffp.hnair.com/FFPClub/member/getPassword'
      // const { userType, isModal } = this

      // if (isModal) {
      //   window.__MICRO_ROOT__?.router?.push({
      //     pathname: microBaseUrl + '/forget-password',
      //     query: {
      //       userType
      //     }
      //   })
      // } else {
      //   this.$router.push(`/forget-password?userType=${userType}`)
      // }
    },
    handleUniTrack (values, error) {
      try {
        const trackParams = { common_login_mode: typeMap[values.type] }
        if (error) {
          trackParams.inf_error_info = error.message
        }
        window.__MICRO_ROOT__?.api?.track?.('UNI_Login', trackParams)
      } catch (error) {
        console.log('error >>>> ', error.message)
      }
    },
    async handleSysConfig () {
      try {
        const params = { code: 'member_login_config' }
        const data = await getSysConfig(params)
        this.rule = data.rule
      } catch (error) {
      }
    }
  }
}
</script>
